import React from 'react';
import { Link, withRouter } from 'react-router-dom'

const CartHeader = ({ item, total, symbol, removeFromCart, cartList, itemNumber }) => (
    <li className={(cartList.length - 1 == itemNumber) ? "cart-contain-li-bottom-none" : "cart-contain-li-bottom"}>
        <div className="media cart-media">
            <Link to={`${process.env.PUBLIC_URL}/PD/${item.RID_LOT_CD}`}>
                <img alt="" className="mr-3" src={`${item.RID_IMAGE_FILE_NAME}`} />
            </Link>
            <div className="cart-contain-content">
                <div className="left-item w-75">
                    <Link to={`${process.env.PUBLIC_URL}/PD/${item.RID_LOT_CD}`}>
                        <h6>{item.RID_SKU_DESC}</h6>
                    </Link>
                    <h6><span>Qty: {item.RID_QTY}</span></h6>
                </div>
                <div className="right-item w-25">
                    <h6><span>Rs. {item.RID_PRICE}</span></h6>
                </div>
            </div>
        </div>
    </li>
)



export default withRouter(CartHeader);
